import { Link } from 'react-router-dom';
import { featuredWorks } from '@/mocks/photography';

export default function FeaturedWorks() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col sm:flex-row items-end justify-between mb-12">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
              精选作品
            </h2>
            <p className="text-foreground-600 text-sm">用心之作，每一张都是艺术品</p>
          </div>
          <Link
            to="/category"
            className="whitespace-nowrap mt-4 sm:mt-0 flex items-center gap-1 text-primary-500 text-sm font-medium hover:text-primary-600 transition-colors cursor-pointer"
          >
            查看全部作品 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {featuredWorks.map((work) => (
            <Link
              key={work.id}
              to={`/category?type=${work.category}`}
              className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 cursor-pointer"
              data-product-shop
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={work.image}
                  alt={work.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                  <p className="text-white text-sm font-medium">{work.title}</p>
                  <p className="text-white/70 text-xs mt-1">{work.description}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}